import type { ArtistListItem } from "../../types";
import { useEdition } from "../../hooks/useEdition";
import { getImageUrl } from "../../lib/image";
import { getLocalizedName } from "../../lib/localization";
import { ImageWithSkeleton } from "../ui/ImageWithSkeleton";

type ArtistCardProps = {
  artist: ArtistListItem;
  onClick: () => void;
};

const MusicIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export function ArtistCard({ artist, onClick }: ArtistCardProps) {
  const { locale, edition } = useEdition();
  const fallback = edition?.default_locale_code;
  const imageUrl = getImageUrl(artist.image, "medium");
  const categories = artist.categories.slice(0, 2);

  return (
    <button type="button" className="festapp-artist-card" data-item-id={artist._id} onClick={onClick}>
      <div className="festapp-artist-card-image">
        <ImageWithSkeleton
          src={imageUrl}
          alt={artist.name}
          fallbackIcon={MusicIcon}
        />
      </div>
      <div className="festapp-artist-card-content">
        <h3 className="festapp-artist-card-name">{artist.name}</h3>
        {categories.length > 0 ? (
          <p className="festapp-artist-card-categories">
            {categories
              .map((cat) => getLocalizedName(cat, locale, fallback))
              .filter(Boolean)
              .join(", ")}
          </p>
        ) : (
          <p className="festapp-artist-card-categories">&nbsp;</p>
        )}
      </div>
    </button>
  );
}
